import React from 'react';
var globalAlloyContextsKeyName = '__AlloyContexts__';
export var getOrCreateGlobalContext = function getOrCreateGlobalContext(name) {
  var contexts = window[globalAlloyContextsKeyName] || {};

  if (!window[globalAlloyContextsKeyName]) {
    window[globalAlloyContextsKeyName] = contexts;
  }

  if (!contexts[name]) {
    contexts[name] = /*#__PURE__*/React.createContext(undefined);
  }

  return contexts[name];
};
export var getGlobalContext = function getGlobalContext(name) {
  var _window$globalAlloyCo;

  return (_window$globalAlloyCo = window[globalAlloyContextsKeyName]) === null || _window$globalAlloyCo === void 0 ? void 0 : _window$globalAlloyCo[name];
};
export var CONTEXT_NAMES = {
  LocaleContext: 'LocaleContext',
  CompaniesContext: 'CompaniesContext',
  AlloyLaunchDarklyContext: 'AlloyLaunchDarklyContext',
  ProjectEntitlementsContext: 'ProjectEntitlementsContext',
  NotificationsContext: 'NotificationsContext',
  AccountEntitlementsContext: 'AccountEntitlementsContext',
  ProjectsContext: 'ProjectsContext',
  RolesContext: 'RolesContext',
  UserContext: 'UserContext',
  UsersContext: 'UsersContext',
  RelationshipsContext: 'RelationshipsContext',
  EntitiesCacheContext: 'EntitiesCacheContext',
  SideNavigationContext: 'SideNavigationContext',
  CurrentProjectIdContext: 'CurrentProjectIdContext',
  CurrentAccountIdContext: 'CurrentAccountIdContext',
  CurrentProductIdContext: 'CurrentProductIdContext',
  CurrentToolIdContext: 'CurrentToolIdContext',
  DatePickerContext: 'DatePickerContext'
};
//# sourceMappingURL=globalContexts.js.map